import * as React from 'react';

export class NotFound extends React.Component {
  public render() {
    return (
      <div className="not-found container">
        <h1>404 Not Found</h1>
        <p>The page you are looking for does not exist.</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/not-found.tsx